import React from 'react';
function Dropdown({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.93 9H4.07C3.48 9 3 9.417 3 9.931v4.138c0 .514.48.931 1.07.931h15.86c.59 0 1.07-.417 1.07-.931V9.931C21 9.417 20.52 9 19.93 9z"
      />
      <path strokeLinecap="round" d="M16.5 11.5l1 1 1-1" />
    </svg>
  );
}

export default Dropdown;
